import React from 'react';
import { Link } from 'react-router-dom';
import './PostLoginFooter.scss';

/**
 * Footer shown once an investor is signed in.
 *
 * These four used to open modals holding their own copies of the Disclaimer, Privacy
 * Policy and Terms — a second set of legal text that had already drifted from the
 * pages at /disclaimer, /privacy-policy and /terms-use — plus an "FAQs coming soon"
 * panel that was untrue once /faq carried the real questions. They now link to those
 * pages, so there is one copy of each document.
 *
 * They open in a new tab: a signed-in investor is usually mid-task, and reading the
 * Terms should not cost them the page they were on.
 */

const FOOTER_LINKS: { to: string; label: string }[] = [
  { to: '/disclaimer', label: 'Disclaimer' },
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-use', label: 'Terms Of Use' },
  { to: '/faq', label: 'FAQs' },
];

const PostLoginFooter: React.FC = () => (
  <footer className="post-login-footer">
    <div className="footer-content">
      <p className="copyright-text">
        &copy; {new Date().getFullYear()} Facilon Platform. All rights reserved.
      </p>
      <div className="footer-links">
        {FOOTER_LINKS.map((link, i) => (
          <React.Fragment key={link.to}>
            {i > 0 && <span className="separator">|</span>}
            <Link to={link.to} target="_blank" rel="noopener noreferrer">
              {link.label}
            </Link>
          </React.Fragment>
        ))}
      </div>
    </div>
  </footer>
);

export default PostLoginFooter;
